import { Component, OnInit } from '@angular/core';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { Button } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';
import { AccessibilityCheckNameService } from '@client/app/modules/accessibility/services/accessibility-check-name/accessibility-check-name.service';
import { AuditlogService } from '@client/app/pages/admin/auditlog/auditlog.component.service';
import { AuditLogUndoReviewCheckDialogComponent } from '../audit-log-undo-review-check-dialog/audit-log-undo-review-check-dialog.component';

@Component({
    selector: 'mon-audit-log-show-details-dialog',
    standalone: true,
    imports: [
        CommonModule,
        TranslocoModule,
        Button,
        TableModule,
    ],
    providers: [
        DialogService,
    ],
    templateUrl: './audit-log-show-details-dialog.component.html',
    styleUrls: ['./audit-log-show-details-dialog.component.scss'],
})
export class AuditLogShowDetailsDialogComponent implements OnInit {
    name: string | null = null;
    data: { [key: string]: number | string | Record<string, string[]> } = {};
    action: string = '';
    target: string | undefined = '';
    sourceCodeId: number | undefined = undefined;
    domainId: string | number | null = null;

    constructor (
        private readonly dialogService: DialogService,
        private readonly dialogConfig: DynamicDialogConfig,
        private readonly dialogRef: DynamicDialogRef,
        private readonly accessibilityCheckNameService: AccessibilityCheckNameService,
        private readonly auditlogService: AuditlogService,
        private readonly translocoService: TranslocoService,
    ) {}

    ngOnInit (): void {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        this.data = this.dialogConfig.data.log_data || {};
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        this.action = this.dialogConfig.data.action || '';
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        this.target = this.dialogConfig.data.target || '';
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        this.sourceCodeId = this.dialogConfig.data.source_code_id || undefined;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        this.domainId = this.dialogConfig.data.domain_id || null;
        if (this.data.check_id && typeof this.data.check_id === 'number') {
            this.getAccessibilityCheckName(this.data.check_id).then((name) => {
                this.name = name;
            });
        }
    }

    async getAccessibilityCheckName (checkID: number): Promise<string | null> {
        return await this.accessibilityCheckNameService.getName(checkID);
    }

    undoAccessibilityCheck (): void {
        this.dialogRef.close();

        const undoAccessibilityCheckDialogRef = this.dialogService.open(AuditLogUndoReviewCheckDialogComponent, {
            data: {
                domain_id: this.domainId,
                source_code_id: this.sourceCodeId,
                check_id: this.data.check_id,
            },
            header: this.translocoService.translate('adminAuditLog.dialog.undoCheckReview.title'),
            baseZIndex: 10000,
            showHeader: true,
            closable: true,
            dismissableMask: true,
            width: '600px',
        });

        undoAccessibilityCheckDialogRef.onClose.subscribe((result) => {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (result?.success) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
                this.dialogConfig.data.callback?.();
            }
        });
    }

    isAnUndoLog () {
        return this.auditlogService.isAnUndoLog(this.action);
    }

    canUndo () {
        return this.auditlogService.canUndo(this.target);
    }
}
